module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUAQMAAACgZR+HAAAABlBMVEXMAAD////D80ESAAAAEElEQVQI12NksN8owEhbAgDmVxQVXzlhAAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/pe.png
// module id = 901
// module chunks = 0